global.constants = {
    wxappid:'wxf0d70f6da7614f98',
    openid:'',
    secret:'6d1ef5be4f4fa84cc298809bfdac4c30',
    regist:'regist',
    faultpost:'faultpost',
    Suggestion:'suggestion'
};


// WEBPACK FOOTER //
// ./src/views/person/config.js